import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import moment from 'moment'

import TaskItem from './TaskItem'
import TaskEditItem from './TaskEditItem'
import Analytics from 'infra/analytics/Analytics'
import ReminderInstanceUtils from '../reminders/ReminderInstanceUtils'

import TextParser from '../common/TextParser'
import MultiTasksConfirmationDialog, { MultiTasks } from './MultiTasksConfirmationDialog'

export default class TasksModule extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape(),
    dbPath: PropTypes.string,
    doneDBPath: PropTypes.string,
    taskType: PropTypes.string,
    dateStr: PropTypes.string,
    enableReminders: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      doneDBPath: props.doneDBPath ? props.doneDBPath : props.dbPath,
      tasks: {},
      mode: 'view',
      doneList: {},
      showMultiTasksConfirmation: false
    }
    this.showReminder = false
  }

  componentWillMount() {
    firebase.database()
      .ref(this.props.dbPath)
      .on('value', this.onUpdate)
    firebase.database()
      .ref(this.state.doneDBPath)
      .on('value', this.onDoneUpdate)
  }

  componentWillUnmount() {
    firebase.database().ref(this.props.dbPath)
      .off('value', this.onUpdate)
    firebase.database().ref(this.state.doneDBPath)
      .off('value', this.onDoneUpdate)
  }

  onUpdate = snapshot => {
    let value = snapshot.val()
    const list = value && value.list || {}
    this.setState({ tasks: list })
  }

  onDoneUpdate = (snapshot) => {
    let value = snapshot.val()
    const list = value && value.list || {}
    this.setState({ doneList: list })
  }

  //
  //Reminder Operations
  // TODO move these operations to ReminderUtils
  handleReminder(currentTask, newTaskUpdate){

    const newTask = Object.assign({}, currentTask)
    newTask.assignees = Object.assign({}, currentTask.assignees)

    if (!currentTask.reminderId && newTaskUpdate.showReminder){
      //this task got a new reminder
      const reminderId = this.saveReminder(currentTask)
      newTask.reminderId = reminderId
      return newTask
    } else if (currentTask.reminderId && !newTaskUpdate.showReminder){
      //the reminder of this task is being removed
      this.deleteReminder(currentTask.reminderId)
      delete newTask['reminderId']
      return newTask
    } else {
      // treat as no changes
      return newTask
    }
  }

  saveReminder(task){
    const reminderId = ReminderInstanceUtils.getNewKey(
      this.props.jobInfo.id,
      this.props.dateStr
    )
    ReminderInstanceUtils.saveReminder(
      'tasksInstance',
      task.id,
      reminderId,
      this.props.jobInfo.creatorId,
      this.props.jobInfo.id,
      this.props.dateStr
    )
    return reminderId
  }

  deleteReminder(reminderId){
    ReminderInstanceUtils.deleteReminder(
      reminderId,
      this.props.jobInfo.id,
      this.props.dateStr
    )
  }


  handleTaskCheck = task => {
    const updates = {}
    const doneStatus = !task.done

    if (doneStatus){
      Analytics.track(Analytics.TASK_COMPLETED)
    }

    updates[this.state.doneDBPath + '/list/' + task.id + '/done'] = doneStatus
    updates[this.state.doneDBPath + '/list/' + task.id + '/lastCheckTime'] =
      moment().format('YYYY-MM-DD')
    firebase.database().ref().update(updates)
  }

  handleSave = (currentTask, newTaskUpdate) => {
    const updates = this.handleReminder(currentTask, newTaskUpdate)
    updates.text = newTaskUpdate.text

    firebase.database()
      .ref(`${this.props.dbPath}/list/${currentTask.id}`)
      .set(updates)
  }

  handleCreateCancel = () => {
    this.setState({ mode: 'view' })
  }

  handleCreate = ({ text, showReminder }) => {
    const tasksList = TextParser.parse(text)
    if (tasksList.length > 1) {
      this.setState({
        showMultiTasksConfirmation: true,
        tasksList,
        text
      })
      this.showReminder = showReminder
    }
    else {
      this.createTasks(tasksList, showReminder)
    }
  }

  handleMultiTaskConfirmationResult = result => {
    if (result === MultiTasks) {
      this.createTasks(this.state.tasksList, this.showReminder)
    }
    else {
      this.createTasks([this.state.text], this.showReminder)
    }
    this.showReminder = false
    this.setState({
      showMultiTasksConfirmation: false
    })
  }

  handleMultiTaskConfirmationCancelled = () => {
    this.setState({
      showMultiTasksConfirmation: false
    })
  }

  createTasks = (tasksList, showReminder) => {
    for (const text of tasksList) {
      const dbList = firebase.database().ref(this.props.dbPath + '/list/')
      const key = dbList.push().key

      //reminder ops
      let reminderId = null
      if (showReminder){
        reminderId = this.handleReminder({id: key}, { showReminder }).reminderId
      }
      dbList.child(key).set({
        creationDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        text,
        reminderId,
        done: false,
        id: key,
        assignees: {
          open: true
        }
      })
    }
    this.setState({ mode: 'view' })
    if (tasksList.length > 1) {
      Analytics.track(Analytics.BULK_TASKS_CREATED, { count: tasksList.length })
    }
    else {
      Analytics.track(Analytics.TASK_CREATED)
    }
  }

  handleTaskDeleted = task => {
    this.handleReminder(task, {})
    firebase.database()
      .ref(this.props.dbPath + '/list/' + task.id + '/deleted')
      .set(true)
  }

  handleAddNew = event => {
    event.preventDefault()
    this.setState({ mode: 'add' })
  }

  renderTasks() {
    const views = []
    for(const key in this.state.tasks) {
      let task = Object.assign({}, this.state.tasks[key])
      if (task.deleted) {
        continue
      }
      if (this.state.doneList.hasOwnProperty(task.id)) {
        task = Object.assign(task, this.state.doneList[task.id])
      }
      views.push(
        <TaskItem
          key={task.id}
          dbPath={this.props.dbPath + '/list/' + task.id}
          task={task}
          workers={this.props.jobInfo.modules.workers}
          enableReminders={this.props.enableReminders}
          onCheck={this.handleTaskCheck}
          onDelete={this.handleTaskDeleted}
          onSave={this.handleSave} />
      )
    }
    return views
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {this.renderTasks()}
        <div style={styles.footer}>
          {this.state.mode === 'view'
            ? <div style={styles.addTask} onTouchTap={this.handleAddNew}>Add task ...</div>
            : <TaskEditItem
              mode='add'
              enableReminders={this.props.enableReminders}
              onCancel={this.handleCreateCancel}
              onSave={this.handleCreate} />
          }
        </div>
        <MultiTasksConfirmationDialog
          open={this.state.showMultiTasksConfirmation}
          onDialogResult={this.handleMultiTaskConfirmationResult}
          onRequestClose={this.handleMultiTaskConfirmationCancelled} />
      </div>
    )
  }
}

const styles = {
  footer: {
    marginTop: 8
  },
  addTask: {
    cursor: 'pointer',
    color: '#356992',
    fontSize: 14
  }
}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/tasks/TasksModule.js